import styled from 'styled-components';
import { DASHBOARD_STYLED_CONSTS } from '@components/common';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  padding-top: var(--space-400);
  padding-bottom: var(--space-400);
  margin-top: var(--space-400);
  flex-direction: column;
  align-items: center;
  gap: var(--space-600);
  align-self: stretch;

  position: relative;
  left: -${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL}px;
  width: calc(100% + ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL * 2}px);

  ${mediaQueries.tablet} {
    width: 100%;
    position: unset;
    margin-top: var(--space-500);
    padding: var(--space-1000) 0;
  }

  border-radius: var(--radius-brand);
  background: var(--bg-secondary);
`;
export const InnerContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-600);
  background: var(--bg-secondary);

  max-width: 100%;

  ${mediaQueries.tablet} {
    max-width: 880px;
  }
`;
export const TopContainer = styled.div `
  text-align: start;
  padding-left: var(--space-400);

  ${mediaQueries.tablet} {
    text-align: center;
    padding-left: unset;
  }

  & > * + * {
    margin-top: var(--space-200);
  }
`;
export const Title = styled.h3 `
  font-family: 'PP Telegraf';
  font-size: var(--font-size-500);
  font-style: normal;
  font-weight: 600;
  line-height: var(--font-line-height-400); /* 120% */
  letter-spacing: var(--font-letter-spacing-denser);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-600);
    line-height: var(--font-line-height-500);
  }
`;
export const Subtitle = styled.p `
  color: var(--text-secondary);

  a {
    text-decoration-line: underline;
    text-underline-offset: 25%;
    text-underline-position: from-font;
  }
`;
export const Recommendations = styled.div `
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);

  max-width: 100%;
  padding: 0 var(--space-400);

  ${mediaQueries.tablet} {
    max-width: 880px;
    gap: var(--space-400);
  }
`;
export const Suggestion = styled.div `
  width: 100%;
  background: var(--bg-primary);
  border-radius: var(--radius-brand);

  & + & {
    margin-top: -1px;
  }

  ${mediaQueries.tablet} {
    position: static;
    width: auto;

    & + & {
      margin-top: 0;
    }
  }
`;
